@if (model) {
<product-layout [variant]="model.productLayoutVariant"
                [product]="model" />
}